module.exports = __webpack_public_path__ + "files/0e5f25b0c0784b7c6d9d1f2037e75267.png";